<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Dedication">
<h1 class="fm_head" id="ded"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><a href="#/text/9780063079441_Contents#rded"><b>Dedication</b></a></span></h1>
<p class="ded_para">To Rachel, Sarah, and Eleanor<span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063079441_Dedication.vue?9207655e